import React, { useEffect} from 'react'
import { useDispatch } from 'react-redux'
import { Link, Redirect, useHistory, useParams } from 'react-router-dom'
import { Divider, EInputTemplate, Input } from '../../components'
import {
  Container,
  StyledData,
  StyledEntity,
  Image,
  Title,
  StyledTitle,
  DeleteButton,
  Div,
  StyledInputWrapper,
  StyledTextArea,
  Label,
  StyledLink,
  ButtonContainer,
} from './styled'
import { Assets } from '../../assets'
import { useTypedSelector } from '../../hooks'
import { Log } from '../../utils'
import { RoutesTree } from '../../router'
import { deleteComplaintAction, getComplaintByIdAction } from '../../store'
import moment from 'moment'

// @ts-ignore
const ComplaintInfo: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const history = useHistory()

  const dispatch = useDispatch()

  const { complaint } = useTypedSelector(store => store.feedback)
  const { user } = useTypedSelector(state => state.user)

  if (!user?.access?.complaint) {
    return <Redirect to={RoutesTree.notFound.path} />
  }

  const onPressDeleteComplaint = async () => {
    try {
      const result = window.confirm('Удалить жалобу?')

      if (result) {
        dispatch(
          deleteComplaintAction({
            authorization: '',
            id,
          }),
        )

        history.goBack()
      }
    } catch (error) {
      Log.ruddy('Event: onPressDeleteComplaint')
    }
  }
  // eslint-disable-next-line
  useEffect(() => {
    if (id) {
      dispatch(getComplaintByIdAction.request({ id }))
    }
  }, [id])

  return (
    <Container>
      <StyledTitle>
        {Assets.LEFT_ARROW_ICON ? (
          <Link
            to={{
              pathname: RoutesTree.complaint.path,
            }}
          >
            <Image src={Assets.LEFT_ARROW_ICON} />
          </Link>
        ) : (
          ''
        )}

        <Title>Жалоба</Title>

        <Div> </Div>
      </StyledTitle>

      <Divider height={10} />

      <StyledData>
        <StyledEntity>
          <Input
            label="Название"
            name="title"
            value={complaint?.title ?? '-'}
            template={EInputTemplate.DEFAULT}
            onChange={() => {}}
            disabled
          />
        </StyledEntity>

        <StyledInputWrapper>
          <Label>Описание</Label>

          <Divider height={10} />

          <StyledTextArea
            name="description"
            value={complaint?.description ?? '-'}
            onChange={() => {}}
            disabled
          />

          <Divider height={5} />
        </StyledInputWrapper>

        <Divider height={10} />

        <StyledEntity>
          <Input
            label="Название клиники"
            name="clinicTitle"
            value={complaint?.clinic?.name?.uk ?? '-'}
            template={EInputTemplate.DEFAULT}
            onChange={() => {}}
            disabled
          />
        </StyledEntity>

        <Divider height={10} />

        <StyledEntity>
          <Input
            label="Дата и время создания"
            name="date"
            value={moment(complaint?.createdAt ?? '-').format(
              'HH:mm DD.MM.YYYY',
            )}
            template={EInputTemplate.DEFAULT}
            onChange={() => {}}
            disabled
          />
        </StyledEntity>

        <Divider height={20} />

        <ButtonContainer>
          <StyledLink
            to={{ pathname: `/clinic-info/${complaint?.clinic?._id ?? ''}` }}
          >
            Перейти к клинике
          </StyledLink>

          <DeleteButton onClick={onPressDeleteComplaint}>Удалить</DeleteButton>
        </ButtonContainer>
        <Divider height={10} />
      </StyledData>
    </Container>
  )
}

export default ComplaintInfo
